import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=b84493b8&scoped=true&"
import script from "./MyNews.vue?vue&type=script&lang=js&"
export * from "./MyNews.vue?vue&type=script&lang=js&"
import style0 from "./MyNews.vue?vue&type=style&index=0&id=b84493b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84493b8",
  null
  
)

export default component.exports